import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@app/hooks/reduxHooks';

import { useTranslation } from 'react-i18next';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { doLogin } from '@app/store/slices/authSlice';
import { notificationController } from '@app/controllers/notificationController';
import * as S from './LoginForm.styles';
import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';
import { setUser } from '@app/store/slices/userSlice';
import { getProfile } from '@app/api/auth.api';
import { UserModel } from '@app/domain/UserModel';
import { consumeReturnTo } from '@app/smart-audit/auth/returnTo';

interface LoginFormData {
  username: string;
  password: string;
}

export const initValues: LoginFormData = {
  password: '123456aA@',
  username: 'admin',
};

export const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState(false);

  const handleSubmit = (values: LoginFormData) => {
    setLoading(true);
    dispatch(doLogin(values))
      .unwrap()
      .then((resp) => {
        if (!resp) {
          setLoading(false);
          return;
        }

        getProfile().then((response) => {
          console.log('getProfile ', response);
          if (response.data.userAccount) {
            const user: UserModel = {
              userId: response.data.userId,
              userName: response.data.userAccount.username,
              email: response.data.email,
              fullName: response.data.fullName,
              imgUrl: response.data.avatarImageUrl,
              isRoot: response.data.userAccount.isRoot,
              userCode: response.data.userAccount.userCode,
            };
            // persistUser(user);
            dispatch(setUser(user));
            setLoading(false);
            navigate(consumeReturnTo() ?? '/');
          }
        });
      })
      .catch((err) => {
        notificationController.error({ message: err.message });
        setLoading(false);
      });
  };

  return (
    <Auth.FormWrapper>
      <BaseForm layout="vertical" onFinish={handleSubmit} requiredMark="optional">
        <Auth.FormTitle>{t('common.login')}</Auth.FormTitle>
        <S.LoginDescription>{t('login.loginInfo')}</S.LoginDescription>
        <Auth.FormItem
          name="username"
          label={t('profile.nav.personalInfo.username')}
          rules={[{ required: true, message: t('common.requiredField') }]}
        >
          <Auth.FormInput placeholder={t('profile.nav.personalInfo.username')} />
        </Auth.FormItem>
        <Auth.FormItem
          label={t('common.password')}
          name="password"
          rules={[{ required: true, message: t('common.requiredField') }]}
        >
          <Auth.FormInputPassword placeholder={t('common.password')} />
        </Auth.FormItem>
        <Auth.ActionsWrapper>
          <BaseForm.Item name="rememberMe" valuePropName="checked" noStyle>
            <Auth.FormCheckbox>
              <S.RememberMeText>{t('login.rememberMe')}</S.RememberMeText>
            </Auth.FormCheckbox>
          </BaseForm.Item>
        </Auth.ActionsWrapper>
        <BaseForm.Item noStyle>
          <Auth.SubmitButton type="primary" htmlType="submit" loading={isLoading}>
            {t('common.login')}
          </Auth.SubmitButton>
        </BaseForm.Item>
        <Auth.FooterWrapper>
          <Auth.Text>
            {t('login.noAccount')}{' '}
            <Link to="mailto:hieu.pham-trong@hitachienergy.com">
              <Auth.LinkText>{t('Admin')}</Auth.LinkText>
            </Link>
          </Auth.Text>
        </Auth.FooterWrapper>
      </BaseForm>
    </Auth.FormWrapper>
  );
};
